angular.module('app').config(serviceItemsRouting);

function serviceItemsRouting($routeProvider) {
  $routeProvider
    .when('/service_items', {
      pageTitle: 'SERVICE_ITEMS',
      template: '<service-items-page></service-items-page>',
      breadcrumb: {
        label: 'COMPANY_SETTINGS',
        parent: 'ng/company_settings',
      },
      menu: 'settings',
      accessPermission: 'index_serviceitem_accountadmin',
      authReq: true,
    })
    .when('/service_items/new', {
      pageTitle: 'ADD_SERVICE_ITEM',
      template: '<service-item-page></service-item-page>',
      breadcrumb: {
        label: 'SERVICE_ITEMS',
        parent: 'service_items',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'create_serviceitem_accountadmin',
      authReq: true,
    })
    .when('/service_items/:id', {
      params: {
        mode: null,
        activeTab: 0,
      },
      pageTitle: 'SERVICE_ITEM_DETAIL',
      template: '<service-item-page></service-item-page>',
      breadcrumb: {
        label: 'SERVICE_ITEMS',
        parent: 'service_items',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'show_serviceitem_accountadmin',
      authReq: true,
    });
}

serviceItemsRouting.$inject = ['$routeProvider'];
